import { boolean, string } from "yup";
export const soadAssessmentCompletionStatusSchema = string()
    .oneOf(["not-started", "in-progress", "completed"])
    .default("not-started");
/**
 * The SOAD's judgement on whether disclosing a certificate's reasons to the
 * patient would be likely to cause serious harm. Starts unanswered so the
 * judgement has to be made rather than defaulted into.
 */
export const disclosureHarmfulSchema = boolean()
    .default(null)
    .required("Please confirm whether disclosure of these reasons would be likely to cause serious harm");
//# sourceMappingURL=helpers.js.map